/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFreelancersListRequest
 */
export interface CreateFreelancersListRequest {
    /**
     * Name of the list
     * @type {string}
     * @memberof CreateFreelancersListRequest
     */
    name: string;
    /**
     * Whether the list is shared within the company or private
     * @type {boolean}
     * @memberof CreateFreelancersListRequest
     */
    sharedWithinCompany: boolean;
    /**
     * Identifier of the profile
     * @type {string}
     * @memberof CreateFreelancersListRequest
     */
    initialProfileIdToAdd: string;
}

/**
 * Check if a given object implements the CreateFreelancersListRequest interface.
 */
export function instanceOfCreateFreelancersListRequest(value: object): value is CreateFreelancersListRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('sharedWithinCompany' in value) || value['sharedWithinCompany'] === undefined) return false;
    if (!('initialProfileIdToAdd' in value) || value['initialProfileIdToAdd'] === undefined) return false;
    return true;
}

export function CreateFreelancersListRequestFromJSON(json: any): CreateFreelancersListRequest {
    return CreateFreelancersListRequestFromJSONTyped(json, false);
}

export function CreateFreelancersListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFreelancersListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'sharedWithinCompany': json['sharedWithinCompany'],
        'initialProfileIdToAdd': json['initialProfileIdToAdd'],
    };
}

export function CreateFreelancersListRequestToJSON(value?: CreateFreelancersListRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'sharedWithinCompany': value['sharedWithinCompany'],
        'initialProfileIdToAdd': value['initialProfileIdToAdd'],
    };
}

